import {Component, Input, OnInit} from '@angular/core';
import {BaseComponent} from '../../../shared/components/base/base.component';
import {UserService} from '../../../shared/services/user.service';
import {TitleService} from '../../../shared/services/title.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.reducer';

@Component({
  selector: 'app-name-email',
  templateUrl: './name-email.component.html',
  styleUrls: ['./name-email.component.css'],
})
export class NameEmailComponent extends BaseComponent implements OnInit {

  @Input() embedded = false;

  constructor(
      protected store: Store<AppState>,
      private userService: UserService,
      private titleService: TitleService) {
    super(store);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.embedded)
      this.titleService.setTitle($localize`My name and email`);
  }


}
